export default {
  data() {
    return {
      rateChangesOptions: [
        { value: true, title: "Yes" },
        { value: false, title: "No" },
      ]
    }
  }
}